import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { t } from 'i18next';
import CrudBase from "src/components/CrudBase";
import InvoiceExpeditor from 'src/models/invoiceExpeditor';
import InvoiceExpeditorForm from './InvoiceExpeditorForm';
import DialogContent from '@mui/material/DialogContent';
import Avatar from '@mui/material/Avatar';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import anyToString from "src/utils/anyToString";
import { BASE_URL } from "src/utils/httpHelper";

export function InvoiceExpeditors() {
    return (
        <CrudBase<InvoiceExpeditor>
            resource="invoice-expeditors"
            indexColumns={['rfc', 'name']}
            showModalColumns={['rfc','name','created_at','updated_at']}
            permissions={{
                'view' : 'invoice_catalogs.view',
                'list' : 'invoice_catalogs.list',
                'create' : 'invoice_catalogs.create',
                'edit' : 'invoice_catalogs.edit',
                'delete' : 'invoice_catalogs.delete',
            }}
            Form={InvoiceExpeditorForm}
            CustomShow={({item: expeditor}) =>
                <DialogContent>
                    <Typography variant="subtitle2">
                        <Grid container spacing={0}>
                            <Grid item xs={12} md={12} display={'flex'} justifyContent={'center'} alignItems={'center'} flexDirection={'column'}>
                                <Box
                                    component="img"
                                    sx={{
                                        maxHeight: { xs: 150 },
                                        maxWidth: { xs: 350 },
                                    }}
                                    alt="Logo"
                                    src={`${BASE_URL}/api/invoice-expeditor/get-logo?rfc=${expeditor.rfc}&time=${Date.now()}`}
                                />
                                <Typography variant='h4'>{expeditor.name}</Typography>
                            </Grid>
                            <Grid item mb={2} xs={12}></Grid>
                            <Grid item xs={12} sm={4} md={3} textAlign={{ sm: 'right' }}>
                                <Box pr={3}>
                                    {t(('FIELDS.RFC').toUpperCase())}:
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={8} md={9} style={{ color: "black" }}>
                                <b>{expeditor.rfc}</b>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} textAlign={{ sm: 'right' }}>
                                <Box pr={3}>
                                    {t(('FIELDS.NAME').toUpperCase())}:
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={8} md={9} style={{ color: "black" }}>
                                <b>{expeditor.name}</b>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} textAlign={{ sm: 'right' }}>
                                <Box pr={3}>
                                    {t(('FIELDS.POSTAL_CODE').toUpperCase())}:
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={8} md={9} style={{ color: "black" }}>
                                <b>{expeditor.postal_code}</b>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} textAlign={{ sm: 'right' }}>
                                <Box pr={3}>
                                    {t(('FIELDS.TAX_REGIME').toUpperCase())}:
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={8} md={9} style={{ color: "black" }}>
                                <b>{expeditor.tax_regime}</b>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} textAlign={{ sm: 'right' }}>
                                <Box pr={3}>
                                    {t(('FIELDS.STREET').toUpperCase())}:
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={8} md={9} style={{ color: "black" }}>
                                <b>{expeditor.street}</b>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} textAlign={{ sm: 'right' }}>
                                <Box pr={3}>
                                    {t(('FIELDS.SUBURB').toUpperCase())}:
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={8} md={9} style={{ color: "black" }}>
                                <b>{expeditor.suburb}</b>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} textAlign={{ sm: 'right' }}>
                                <Box pr={3}>
                                    {t(('FIELDS.CITY').toUpperCase())}:
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={8} md={9} style={{ color: "black" }}>
                                <b>{expeditor.city}</b>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} textAlign={{ sm: 'right' }}>
                                <Box pr={3}>
                                    {t(('FIELDS.STATE').toUpperCase())}:
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={8} md={9} style={{ color: "black" }}>
                                <b>{expeditor.state}</b>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} textAlign={{ sm: 'right' }}>
                                <Box pr={3}>
                                    {t(('FIELDS.COUNTRY').toUpperCase())}:
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={8} md={9} style={{ color: "black" }}>
                                <b>{expeditor.country}</b>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} textAlign={{ sm: 'right' }}>
                                <Box pr={3}>
                                    {t(('FIELDS.EXPEDITION_PLACE').toUpperCase())}:
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={8} md={9} style={{ color: "black" }}>
                                <b>{expeditor.expedition_place}</b>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} textAlign={{ sm: 'right' }}>
                                <Box pr={3}>
                                    {t(('FIELDS.CREATED_AT').toUpperCase())}:
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={8} md={9} style={{ color: "black" }}>
                                <b>{anyToString(expeditor.created_at)}</b>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} textAlign={{ sm: 'right' }}>
                                <Box pr={3}>
                                    {t(('FIELDS.UPDATED_AT').toUpperCase())}:
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={8} md={9} style={{ color: "black" }}>
                                <b>{anyToString(expeditor.updated_at)}</b>
                            </Grid>
                        </Grid>
                    </Typography>
                </DialogContent>
            }
            deleteButton={true}
            searchInput={true}
            Icon={ManageAccountsIcon} />
    );
}
